import { render, staticRenderFns } from "./SicReportDetails.vue?vue&type=template&id=f2393daa&"
import script from "./SicReportDetails.vue?vue&type=script&lang=js&"
export * from "./SicReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./SicReportDetails.vue?vue&type=style&index=0&id=f2393daa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports